import { useState } from 'react';

export type ActiveSection =
  | 'dashboard'
  | 'tumBasvurular'
  | 'lansmanaKatilanlar'
  | 'potansiyelBasvurular'
  | 'manuelEkle'
  | 'excelYukle'
  | 'raporlar'
  | 'ayarlar'
  | 'detay';

interface SidebarProps {
  active: ActiveSection;
  onChange: (s: ActiveSection) => void;
}

const navItems: { key: ActiveSection; label: string; icon: string; divider?: boolean }[] = [
  { key: 'dashboard', label: 'Dashboard', icon: 'ri-dashboard-3-line' },
  { key: 'tumBasvurular', label: 'Tüm Başvurular', icon: 'ri-file-list-3-line' },
  { key: 'lansmanaKatilanlar', label: 'Lansmana Katılanlar', icon: 'ri-rocket-2-line' },
  { key: 'potansiyelBasvurular', label: 'Potansiyeller', icon: 'ri-user-search-line' },
  { key: 'manuelEkle', label: 'Manuel Ekle', icon: 'ri-user-add-line', divider: true },
  { key: 'excelYukle', label: 'Excel Yükle', icon: 'ri-file-excel-2-line' },
  { key: 'raporlar', label: 'Raporlar', icon: 'ri-bar-chart-2-line', divider: true },
  { key: 'ayarlar', label: 'Ayarlar', icon: 'ri-settings-4-line' },
];

export default function Sidebar({ active, onChange }: SidebarProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside className={`flex flex-col h-screen bg-[#080c16] border-r border-white/[0.06] transition-all duration-300 ${collapsed ? 'w-16' : 'w-60'} shrink-0 fixed top-0 left-0 z-30`}>
      {/* Logo */}
      <div className="flex items-center gap-3 px-4 py-5 border-b border-white/[0.06]">
        <img src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b96ea752e56aba4c8821d7f8f5ab39a4.png"
          alt="Logo" className="w-8 h-8 object-contain shrink-0" />
        {!collapsed && (
          <div className="overflow-hidden">
            <p className="text-white font-bold text-sm leading-tight whitespace-nowrap">Franchise</p>
            <p className="text-amber-400 text-[10px] font-medium tracking-widest uppercase whitespace-nowrap">Launch Panel</p>
          </div>
        )}
        <button onClick={() => setCollapsed(!collapsed)}
          className="ml-auto w-6 h-6 flex items-center justify-center text-white/30 hover:text-white/70 transition-colors cursor-pointer">
          <i className={`ri-${collapsed ? 'menu-unfold' : 'menu-fold'}-line text-base`} />
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 py-4 overflow-y-auto">
        {navItems.map((item) => {
          const isActive = active === item.key;
          return (
            <div key={item.key}>
              {item.divider && !collapsed && (
                <div className="mx-4 my-2 border-t border-white/[0.05]" />
              )}
              <button onClick={() => onChange(item.key)}
                className={`w-full flex items-center gap-3 px-4 py-3 mb-0.5 transition-all duration-200 cursor-pointer group relative ${isActive ? 'text-white bg-amber-500/10 border-r-2 border-amber-400' : 'text-white/40 hover:text-white/80 hover:bg-white/[0.04]'}`}>
                {isActive && <span className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-6 bg-amber-400 rounded-r" />}
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-base ${isActive ? 'text-amber-400' : ''}`} />
                </span>
                {!collapsed && <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>}
              </button>
            </div>
          );
        })}
      </nav>

      {/* Footer */}
      {!collapsed && (
        <div className="px-4 py-4 border-t border-white/[0.06]">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-amber-500/20 flex items-center justify-center shrink-0">
              <i className="ri-user-line text-amber-400 text-sm" />
            </div>
            <div>
              <p className="text-white/80 text-xs font-semibold">Yönetici</p>
              <p className="text-white/30 text-[10px]">admin@franchise.com</p>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}
